<template>
    <div>
        <card>
            <template #body>
                <div class="row">
                    <div class="col-sm-9">
                        <h5 class="card-title">Portefeuille</h5>
                        <p class="card-text">Solde actuel: <strong><span
                                    :class="'fs-3 ' + (wallet.balance >= 0 ? ' text-primary ' : ' text-warning ')">{{
                                        formatAmount(wallet.balance ||
                                    0) }}</span> FCFA</strong></p>
                    </div>
                    <div class="col-sm-3 d-flex justify-content-end align-items-start">
                        <button class="btn btn-primary" @click="askEdit('add')">
                            <i class="bi bi-plus me-1"></i>Créditer
                        </button>
                        <button class="btn btn-secondary mx-1" @click="askEdit('subtract')">
                            <i class="bi bi-dash me-1"></i>Débiter
                        </button>
                        <button class="btn btn-warning mx-1" @click="askEdit('correct')">
                            <i class="bi bi-arrows-collapse me-1"></i>Corriger
                        </button>
                    </div>
                </div>
                <div class="row">
                    <transition name="fade">
                        <div class="col-12 mt-3 border  rounded shadow-sm p-1" v-if="showForm">
                            <h5 class="text-end"><span role="button" class="text-warning" @click="showForm = false"><i
                                        class="bi bi-x"></i>Fermer</span></h5>
                            <WalletEditForm :item="wallet" :operation="actions" @edited="walletEdited" />
                        </div>
                    </transition>
                </div>
            </template>
        </card>
        <section-container class="mt-4">
            <h5>Historique des transactions</h5>
            <div class="d-none d-md-block table-responsive">
                <div v-if="walletMovements.length > 0" class="table-responsive ">
                    <table class="table table-hover table-striped align-middle clients-table">
                        <thead class="table-purple text-white">
                            <tr>
                                <th>#</th>
                                <th>Actions</th>
                                <th>Montant</th>
                                <th>Description</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(m, idx) in walletMovements" :key="m.id" class="table-row-hover">
                                <td>{{ idx + 1 }}</td>
                                <td>{{ m.actions }}</td>
                                <td :class="mvtLineClass[m.type]">
                                    {{ m.type == 'debit' ? '-' : '' }} {{ formatAmount(Math.abs(m.amount)) }} FCFA
                                </td>
                                <td>{{ m.description || '—' }}</td>
                                <td>{{ dateFormater.formatDate(m.created_at) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else class="text-muted">Aucune transaction récente.</div>
            </div>
            <div class="d-block d-md-none">
                <div v-if="walletMovements.length > 0" class="bg-white">
                    <div class="card my-1" v-for="(m, idx) in walletMovements" :key="m.id">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-start">
                                <div>
                                    <h6 class="mb-1">{{ m.actions }}</h6>
                                    <p class="mb-1"><small class="text-muted">#{{ idx + 1 }} • {{
                                            dateFormater.formatDate(m.created_at) }}</small></p>
                                    <p class="mb-1"><strong>Montant:</strong> <span :class="mvtLineClass[m.type]">
                                            {{ m.type == 'debit' ? '-' : '' }} {{ formatAmount(Math.abs(m.amount)) }} FCFA
                                        </span></p>
                                    <p class="mb-1"><strong>Description:</strong> {{ m.description || '—' }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="text-muted">Aucune transaction récente.</div>
            </div>

        </section-container>
    </div>
</template>

<script>
import Card from '@/components/elements/Card.vue';
import SectionContainer from '@/components/elements/SectionContainer.vue';
import amountFormater from '@/helpers/amountFormater';
import WalletEditForm from '@/components/forms/WalletEditForm.vue';
import dateFormater from '@/helpers/dateFormater';

export default {
    name: 'WalletView',
    components: {
        Card,
        SectionContainer,
        WalletEditForm
    },
    data() {
        return {
            link: '/wallets',
            wallet: {},
            showForm: false,
            actions: null,
            walletMovements: [],
            mvtLineClass: {
                credit: 'text-success',
                debit: 'text-danger',
                correction: 'text-warning'
            }
        }
    },
    computed: {
        formatAmount() {
            return (amount) => amountFormater.formatAmount(amount);
        },
        movementsUrl() {
            return this.link + '/' + this.wallet.id + '/movements';
        },
        dateFormater() {
            return dateFormater;
        }
    },
    watch: {
        wallet: {
            handler(newVal) {
                if (newVal && newVal.id) {
                    this.getWalletMovements();
                }
            },
            immediate: true
        }
    },

    methods: {
        getWallet() {
            this.$api.get(this.link)
                .then(response => {
                    this.wallet = response.data.data;
                })
                .catch(error => {
                    this.wallet = {};
                    console.error('There was an error fetching the wallet information!', error);
                });
        },
        getWalletMovements() {
            this.$api.get(this.movementsUrl)
                .then(response => {
                    this.walletMovements = response.data.data;
                })
                .catch(error => {
                    this.walletMovements = [];
                    console.error('There was an error fetching the wallet movements!', error);
                });
        },
        askEdit(actions) {
            this.actions = actions;
            this.showForm = true;
        },
        walletEdited() {
            this.showForm = false;
            this.getWallet();
        }
    },
    created() {
        this.getWallet();
    }
}
</script>